import { motion } from 'framer-motion';
import styled from 'styled-components';

export const ModalStyled = styled(motion.div)<{
  $zIndex?: number;
  $width?: string | number;
  $backgroundColor?: string;
}>`
  position: relative;
  background-color: ${({ theme, $backgroundColor }) =>
    $backgroundColor ? $backgroundColor : theme.background};
  z-index: ${({ $zIndex }) => ($zIndex ? `${$zIndex + 2}` : '96')};
  border-radius: 30px;
  width: ${({ $width }) => $width ?? '100%'};
  max-width: calc(100% - 100px);
  overflow: hidden;

  @media (max-width: 800px) {
    max-width: calc(100% - 60px);
    > svg {
      width: 100px;
    }
  }
`;

export const ModalScrollableStyled = styled(motion.div)<{
  $footer?: boolean;
  $numOfFloatingButtons?: number;
  $height?: string;
}>`
  padding: 32px 45px;
  max-height: calc(100vh - 150px);
  ${({ $height }) => $height && `height: ${$height}`};
  /* The footer floats over the list, so the list ends with room to scroll its
     last row out from under it. On a desktop the buttons always sit in one
     row; only on a phone do two of them stack. */
  ${({ $footer }) => $footer && `padding-bottom: 109px;`}

  @media (max-width: 800px) {
    padding: 24px;
    ${({ $footer, $numOfFloatingButtons }) =>
      $footer &&
      `${
        $numOfFloatingButtons === 1
          ? `padding-bottom: 109px;`
          : `padding-bottom: 170px;`
      }`}
  }

  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const ModalOverlay = styled(motion.div)<{
  $zIndex?: number;
}>`
  background-color: ${({ theme }) => theme.darkGray}4D;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ $zIndex }) => ($zIndex ? `${$zIndex}` : '94')};
`;

export const SuccessImage = styled(motion.img)`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 250px;
`;

export const ModalHeader = styled.div`
  background-color: ${({ theme }) => theme.primary};
  height: 100px;
  border-radius: 30px;
  display: flex;
  align-items: center;

  padding: 0 45px;

  /* justify-content: center; */

  @media (max-width: 800px) {
    height: 80px;
    padding: 24px;
  }
`;

export const ModalWrapper = styled.div<{
  $zIndex?: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${({ $zIndex }) => ($zIndex ? `${$zIndex + 1}` : '95')};
`;

export const ModalFooter = styled.div<{
  $numOfFloatingButtons?: number;
}>`
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 1) 30%,
    rgba(255, 255, 255, 0) 100%
  );
  background: -webkit-linear-gradient(
    bottom,
    rgba(255, 255, 255, 1) 30%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: 1;

  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 30px;
  padding: 32px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: end;

  @media (max-width: 800px) {
    flex-direction: column;
    gap: 8px;
    padding: 24px;
  }
`;
